module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict01_sp01-bec7f3789f6495e427112f810e28323c.png";